import { useTheme } from "@mui/material/styles";
import { useMatchQuery } from "./useMatchQuery.js";
const useIsTablet = ()=>{
    const theme = useTheme();
    return useMatchQuery(theme.breakpoints.up('sm'));
};
export { useIsTablet };
